<div class="delino-notification-container">
  <i class="icon-close-o" (click)="close()"></i>
  <div class="delino-notification-brand">
    <img src="./assets/images/delino.png" loading="lazy" height="32px" alt="Delino Logo" />
  </div>
  <div class="delino-notification-text">
    <h6>{{ "ClientApp.Projects.FrameWorkShell.Header.DelinoNotification.NewOrder" | translate }}</h6>
    <p>{{ "ClientApp.Projects.FrameWorkShell.Header.DelinoNotification.OrderReceiveDelinoService" | translate }}</p>
  </div>
  <ssg-button [label]="'ClientApp.Projects.FrameWorkShell.Header.DelinoNotification.ViewOrder' | translate" (click)="showNoti()"></ssg-button>
</div>
